import React from "react";

const Footer = () => {
   return <div className="bg-black text-white p-16 text-center">©2021 Web Development Project</div>;
};

export default Footer;
